import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-baseboard',
  templateUrl: './baseboard.component.html',
  styleUrls: ['./baseboard.component.scss'],
})
export class BaseboardComponent {
  @Output() clickedMenuItem = new EventEmitter();
  @Output() clickedSocialItem = new EventEmitter();

  public currentYear: number;

  constructor() {
    this.currentYear = new Date().getFullYear();
  }
}
